import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { TwinColumnSelectProps } from './twin-column-select.component';
import TwinColumnSelect from './twin-column-select.component';

export interface HfTwinColumnSelectProps<TFieldValues extends FieldValues = FieldValues> extends TwinColumnSelectProps {
  control: Control<TFieldValues>;
  name: string;
}

function HfTwinColumnSelect<TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  id,
  value,
  data,
  textField,
  valueField,
  pageSize,
  label,
  filterLocation,
  fieldValueConverter,
  onChange,
  showAddNewOption,
  readOnly,
  required,
  labelStyles,
  subType,
}: HfTwinColumnSelectProps<TFieldValues>) {
  return (
    <OdinController
      name={name}
      defaultValue={value}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TwinColumnSelect
          id={id}
          value={value}
          data={data}
          textField={textField}
          valueField={valueField}
          pageSize={pageSize}
          onChange={onChange}
          filterLocation={filterLocation}
          label={label}
          showAddNewOption={showAddNewOption}
          readOnly={readOnly}
          required={required}
          error={error?.message}
          labelStyles={labelStyles}
          subType={subType}
        />
      )}
    />
  );
}

export default HfTwinColumnSelect;
